var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert alert-danger text-danger strong m-2 border-0 d-block",staticStyle:{"background-color":"var(--danger-900)"},attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }